import { render, staticRenderFns } from "./BarRadar.vue?vue&type=template&id=083931cf&"
import script from "./BarRadar.vue?vue&type=script&lang=js&"
export * from "./BarRadar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports